module.exports = __webpack_public_path__ + "img/symbol_1.0e56b561.png";